/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { WorkingScheduleBody } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsSchedule: build.query<WorkingScheduleBody, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/master/schedule` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsScheduleApi };
export const { useGetSettingsScheduleQuery, useLazyGetSettingsScheduleQuery } = injectedRtkApi;
